import React from "react"
import { Cliente } from "."
import { obterDadosPessoaisPF } from "../../services/cliente"
import { obterDadosUsuario2 } from "../../services/cookies"
import { executarRequisicaoAutenticada, SessaoExpiradaError } from "../../services/authenticatedRequest"

export const obterDadosCadastrais = async (setDadosPessoais: React.Dispatch<Cliente>, setLoading: React.Dispatch<boolean>, setErro: React.Dispatch<boolean>, setDesconectar: React.Dispatch<boolean>) => {
    setLoading(true)
    setErro(false)
    const { id } = obterDadosUsuario2()

    if (!id) {
        setDesconectar(true)
        setLoading(false)
        return
    }

    try {
        const res = await executarRequisicaoAutenticada((token) => obterDadosPessoaisPF(token, id))
        setDadosPessoais(res.data.resultado.dadosPessoais)
    } catch (error) {
        if (error instanceof SessaoExpiradaError) {
            setDesconectar(true)
        } else {
            setErro(true)
        }
    } finally {
        setLoading(false)
    }
}

export const handleMaskCPF = (cpf: string) => {

    cpf = cpf.replace(/\D/g, "");

    cpf = cpf.replace(/^(\d{3})(\d)/g, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1-$2");

    return cpf;
}

export function handleMaskCEP(
    e: any,
) {
    e = e.replace(/\D/g, "");
    e = e.replace(/^(\d{2})(\d)/g, "$1.$2");
    e = e.replace(/(\d{3})(\d)/, "$1-$2");
    return e
}

export function handleMaskTelefone(
    e: string,
) {
    e = e.replace(/\D/g, "");

    e = e.replace(/^(\d{2})(\d)/g, "($1) $2");
    e = e.replace(/(\d{5})(\d)/, "$1-$2");

    return e
}


export function handleMaskRenda(
    e: string,
) {
    e = e.replace(/[^,.0-9]/g, "");
    e = e.replace(",", ".");
    var count = 0;
    for (let i = 0; i <= e.length; i++) {
        if (e[i] === ".") {
            count = count + 1;
            if (count >= 2) {
                e = e.replace(/[.]/, "");
            }
        }
    }


    return e = "R$ " + e;
}
